import getChecked from 'services/forms/getChecked';
import getTargetName from 'services/forms/getTargetName';
import getTargetValue from 'services/forms/getTargetValue';
import IGlassWallDoor from 'components/interfaces/IGlassWallDoor';
import IWall from 'components/interfaces/IWall';
import IWallMetaData from 'components/interfaces/IWallMetaData';
import store from 'store/store';
import { setWallMetaData } from 'store/selectedWall/actions';

import doorUpdater from './updateDoor';

const getDoorPropertiesHandler =
  (
    doors: IGlassWallDoor[],
    setChangedFirstLastDoor: (changed: boolean) => void,
    setChangedFirstLastDoorInWall: (changed: boolean) => void
  ) =>
  (doorId: number) =>
  (e: any): void => {
    const state = store.getState();
    const targetName = getTargetName(e);
    const wall = state.selectedWall.properties as IWall;
    const wallMetaData = state.selectedWall.metaData as IWallMetaData;

    const updateDoor = doorUpdater(wall);

    const doorToEdit = doors.find(
      (existingDoor): existingDoor is IGlassWallDoor =>
        existingDoor.id === doorId
    );

    if (doorToEdit === undefined) {
      return;
    }

    let newValue = getTargetValue(e);

    if (
      targetName === 'isFirstDoor' ||
      targetName === 'isLastDoor' ||
      targetName === 'woodyLeftExtraWoodyProfile' ||
      targetName === 'woodyLeftExtraAluProfile' ||
      targetName === 'woodyRightExtraWoodyProfile' ||
      targetName === 'woodyRightExtraAluProfile' ||
      targetName === 'woodyLeftElectricalBox' ||
      targetName === 'woodyRightElectricalBox'
    ) {
      newValue = getChecked(e);
      setChangedFirstLastDoor(true);
      setChangedFirstLastDoorInWall(true);
    }

    if (targetName === 'excludeStopper') {
      newValue = !getChecked(e);
    }

    if (targetName === 'hasLeftDoorPrimary') {
      newValue = getChecked(e);
    }

    if (targetName === 'hasSolidSlaveDoor') {
      newValue = getChecked(e);
    }

    if (
      targetName === 'woodyLeftExtraProfileHeight' ||
      targetName === 'woodyRightExtraProfileHeight'
    ) {
      newValue = parseInt(newValue, 10);
    }

    const updatedDoor: IGlassWallDoor = {
      ...doorToEdit,
      [targetName]: newValue,
    };

    if (targetName === 'doorDirection') {
      wall.doorLeafDirection = newValue;
    }

    if (targetName === 'areaName') {
      updatedDoor.doorID = newValue;
      store.dispatch(
        setWallMetaData({
          ...wallMetaData,
          doors: wallMetaData.doors.map((doorMetaData: any) =>
            doorMetaData.doorTempId === updatedDoor.id
              ? { ...doorMetaData, doorId: newValue }
              : doorMetaData
          ),
        })
      );
    }

    if (targetName === 'isFirstDoor' && newValue) {
      updatedDoor.isLastDoor = false;
    }

    if (targetName === 'isLastDoor' && newValue) {
      updatedDoor.isFirstDoor = false;
    }

    updateDoor(doorId, updatedDoor);
  };

export default getDoorPropertiesHandler;
